import { ColumnsToggle as SharedColumnsToggle } from "@/components/shared/columns-toggle"
import { OPTIONAL_COLUMNS, type ColumnKey } from "@/components/alfred/alfred-devices-table"

interface ColumnsToggleProps {
  visibleColumns: Set<ColumnKey>
  onChange: (columns: Set<ColumnKey>) => void
}

export function ColumnsToggle({ visibleColumns, onChange }: ColumnsToggleProps) {
  return <SharedColumnsToggle columns={OPTIONAL_COLUMNS} visibleColumns={visibleColumns} onChange={onChange} />
}
